import {
  changeDirectionWord,
  formatPercentMagnitude,
  isFiniteNumber,
} from './narrativeFormatting';

const TINY_CHANGE_PCT = 0.5;

/**
 * Complete optional trend clause for templates, e.g. ", an increase of 4.8% since 2005".
 * Returns empty string when trend cannot be stated (missing baseline or percent).
 */
export function buildTrendSentence(
  percentChange: number | null | undefined,
  baselineYear: number | null | undefined
): string {
  if (!isFiniteNumber(baselineYear)) return '';
  if (!isFiniteNumber(percentChange)) return '';
  const dir = changeDirectionWord(percentChange);
  if (dir === 'little change') {
    return `, with little change since ${baselineYear}`;
  }
  return `, ${dir} of ${formatPercentMagnitude(percentChange)} since ${baselineYear}`;
}

/** @deprecated Use buildTrendSentence in templates instead of trendPhrase + baselineYear */
export function buildLegacyTrendPhrase(percentChange: number | null | undefined): string {
  if (!isFiniteNumber(percentChange)) return '';
  const dir = changeDirectionWord(percentChange);
  if (dir === 'little change') return 'with little change since';
  return `${dir} of ${formatPercentMagnitude(percentChange)} since`;
}

export function isTinyPercentChange(pct: number): boolean {
  return Math.abs(pct) < TINY_CHANGE_PCT;
}
